import { createFormHook } from '@tanstack/react-form';
import { CategoriesField } from './CategoriesField';
import { fieldContext, formContext } from './contexts';
import { InputField } from './InputField';
import { OpeningHoursField } from './OpeningHoursField';
import { PriceLevelField } from './PriceLevelField';
import { TextareaField } from './TextareaField';

export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    CategoriesField,
    InputField,
    OpeningHoursField,
    PriceLevelField,
    TextareaField,
  },
  formComponents: {},
});
